import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';

import { Theme, rem } from '../../theme';

export const StyledToggleButton = styled(Switch)`
    ${({ theme }: { theme: Theme }) => `
        align-self: center;
        width: ${theme.tggSpacing(rem(7), 17.5)};
        height: ${theme.tggSpacing(rem(4), 10)};
        padding: ${theme.tggSpacing(0, 0)};
        margin-left: auto;
        overflow: visible;

        & .MuiSwitch-track {
            background-color: ${theme.isRebranding(theme.palette.grey[900], theme.palette.tgg.surface.action.selection.deactivatedSwitch)};
            border-radius: ${theme.tggSpacing(rem(4), 10)};
            opacity: 1;
            transition: ${theme.transitions.create(['background-color'], {
                duration: 500,
            })};
        }

        & .MuiSwitch-switchBase {
            padding: ${theme.tggSpacing(0, 0)};
            margin: ${theme.tggSpacing(rem(0.4), 1)};
            transition-duration: 300ms;

            &.Mui-disabled + .MuiSwitch-track {
            background-color: ${theme.isRebranding('inherit', theme.palette.tgg.surface.action.disabled)};
                opacity:  ${theme.isRebranding(0.7, 1)};
            }

            &.Mui-checked {
                color: ${theme.palette.common.white};
                transform: translateX(${theme.tggSpacing(rem(3), 7.5)});

                & + .MuiSwitch-track {
                    background-color: ${theme.isRebranding(theme.palette.primary.main, theme.palette.tgg.surface.action.selection.activated)};
                    border: ${theme.tggSpacing(0, 0)};
                    opacity: 1;
                }

                &.Mui-disabled + .MuiSwitch-track {
                    background-color: ${theme.isRebranding(theme.palette.primary.main, theme.palette.tgg.surface.action.disabled)};
                    opacity: ${theme.isRebranding(0.5, 1)};
                }
            }
        }
        & .MuiSwitch-thumb {
            box-sizing: border-box;
            width: ${theme.tggSpacing(rem(3.2), 8)};
            height: ${theme.tggSpacing(rem(3.2), 8)};
        }

        & .MuiSwitch-switchBase.Mui-disabled .MuiSwitch-thumb {
            color: ${theme.isRebranding(theme.palette.common.white, theme.palette.tgg.icon.action.disabled)};
        }

        & .MuiSwitch-switchBase.Mui-focusVisible .MuiSwitch-thumb {
            color: ${theme.isRebranding(theme.palette.primary.main, theme.palette.common.white)};
            border: ${theme.isRebranding(`0.6rem solid ${theme.palette.common.white}`, 0)} ;
        }

        ${theme.isRebranding(
            '',
            `
                & .MuiSwitch-switchBase:focus-within + .MuiSwitch-track {
                    outline: 0.125rem solid
                        ${theme.palette.tgg.border.focus.main};
                    outline-offset: 0.125rem;
                }
            `,
        )}
    `}
`;
